import {
  FETCH_DEVICE_REQUEST, FETCH_DEVICE_RESPONSE,
  UPDATE_DEVICE_RESPONSE,
  REMOVE_DEVICE_RESPONSE,
  LIST_UNIT_DEVICES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// deviceId -> {device}
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case FETCH_DEVICE_REQUEST: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          isLoading: true,
        },
      }
    }
    case UPDATE_DEVICE_RESPONSE:
    case FETCH_DEVICE_RESPONSE: {
      return {
        ...state,
        [action.device.id]: {
          ...action.device,
        },
      }
    }
    case REMOVE_DEVICE_RESPONSE: {
      const { [action.id]: _, ...s } = state
      return s
    }
    case LIST_UNIT_DEVICES_RESPONSE: {
      const s = { ...state }
      const devices = action.devices || []
      devices.forEach((d) => {
        s[d.id] = d
      })
      return s
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
